import styled from 'styled-components';
import * as Separator from '@radix-ui/react-separator';

interface Props {
  color?: string;
}

export const SeparatorRoot = styled(Separator.Root) <Props>`
  background-color: ${props => props.color ? props.color : 'black'};

  &[data-orientation="horizontal"] {
    height: 1px;
    width: 100%;
  }

  &[data-orientation="vertical"] {
    height: 100%;
    width: 1px;
  }
`;